import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useAppStore } from "../../store";
import { useEffect, useState } from "react";
export var useLayoutInit = function useLayoutInit(props) {
  var menusLoading = useAppStore(function (s) {
    return s.menusLoading;
  });
  var menus = useAppStore(function (s) {
    return s.menus;
  });
  var setErrorCaptureException = useAppStore(function (s) {
    return s.setErrorCaptureException;
  });
  var monitorConfig = useAppStore(function (s) {
    return s.monitorConfig;
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuInit = _useState2[0],
    setMenuInit = _useState2[1];

  //菜单加载成功之后执行初始化框架配置
  useEffect(function () {
    if (!menusLoading && menus !== null && menus !== void 0 && menus.length && !menuInit) {
      setMenuInit(true);
    }
  }, [menus, menusLoading]);

  // 框架生命周期
  useEffect(function () {
    var _props$layoutConfig$l, _props$layoutConfig;
    (_props$layoutConfig$l = (_props$layoutConfig = props.layoutConfig).layoutMounted) === null || _props$layoutConfig$l === void 0 || _props$layoutConfig$l.call(_props$layoutConfig, props);
    // 初始化全局错误事件上报
    var errorCaptureException = props.layoutConfig.errorCaptureException || (monitorConfig === null || monitorConfig === void 0 ? void 0 : monitorConfig.captureException);
    if (errorCaptureException) {
      setErrorCaptureException(errorCaptureException);
    }
    return function () {
      var _props$layoutConfig$l2, _props$layoutConfig2;
      (_props$layoutConfig$l2 = (_props$layoutConfig2 = props.layoutConfig).layoutDestroyed) === null || _props$layoutConfig$l2 === void 0 || _props$layoutConfig$l2.call(_props$layoutConfig2, props);
    };
  }, []);
  return {};
};